import type { TypeStyleData } from './types';

// ----------------------------------------------------------------------------

function setStyleData(element: HTMLElement, data: TypeStyleData): void {
    for (const key of Object.keys(data)) {
        const rawValue = data[key];

        const property = key.replace(/([A-Z])/g, '-$1').toLowerCase();

        const parts = rawValue.trim().split(/\s+/);
        const hasImportant = parts[parts.length - 1].toLowerCase() === 'important';

        const value = hasImportant ? parts.slice(0, -1).join(' ') : rawValue;
        const priority = hasImportant ? 'important' : '';

        element.style.setProperty(property, value, priority);
    }
}

// ----------------------------------------------------------------------------

export default setStyleData;
